import type { SaleDict } from './sale-i18n';

// Vùng "misc": StayDatePicker (lịch chọn ngày dùng trong khối đặt phòng của khách).
// SaleCallbacksSection / SaleWebBookingHint là trang NHÂN VIÊN trong (app) → cố ý giữ tiếng Việt, không i18n.
export const SALE_DICT: SaleDict = {
  'misc.checkin': { vi: 'Nhận phòng', en: 'Check-in', zh: '入住', ko: '체크인', fr: 'Arrivée', ja: 'チェックイン' },
  'misc.checkout': { vi: 'Trả phòng', en: 'Check-out', zh: '退房', ko: '체크아웃', fr: 'Départ', ja: 'チェックアウト' },
  'misc.pickedCheckin': {
    vi: 'Đã chọn nhận phòng {date} — bấm ngày trả phòng.',
    en: 'Check-in {date} selected — now tap your check-out date.',
    zh: '已选择入住日期 {date}，请点击退房日期。',
    ko: '체크인 {date} 선택됨 — 체크아웃 날짜를 눌러 주세요.',
    fr: 'Arrivée le {date} sélectionnée — choisissez maintenant la date de départ.',
    ja: 'チェックイン日 {date} を選択しました — 次にチェックアウト日をタップしてください。',
  },
  'misc.booked': { vi: 'Đã có khách', en: 'Booked', zh: '已被预订', ko: '예약됨', fr: 'Réservé', ja: '予約済み' },
  'misc.loadingCalendar': {
    vi: 'Đang tải lịch trống…',
    en: 'Loading availability…',
    zh: '正在加载空房日历…',
    ko: '예약 가능 일정 불러오는 중…',
    fr: 'Chargement des disponibilités…',
    ja: '空室状況を読み込み中…',
  },
  'misc.calendarLegend': {
    vi: 'Ngày gạch ngang = đã có khách, không đặt được.',
    en: 'Struck-through dates are already booked and cannot be selected.',
    zh: '带删除线的日期已被预订，无法选择。',
    ko: '취소선이 그어진 날짜는 이미 예약되어 선택할 수 없습니다.',
    fr: 'Les dates barrées sont déjà réservées et ne peuvent pas être choisies.',
    ja: '取り消し線の日付はすでに予約済みで、選択できません。',
  },
};
